import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";

const DataTableSecond = ({ columns = [], rows = [], height = 400 }) => {
  return (
    <Paper
      sx={{
        height: height,
        width: "100%",
        border: "none",
        borderRadius: "5px",
        overflow: "hidden",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#7C2EA0",
            color: "#000",
            fontSize: "16px",
            fontWeight: "600",
            borderBottom: "2px solid #6a238a",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#F8EAFF",
          },
          "& .MuiDataGrid-cell": {
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            paddingLeft:"20px"
          },
        }}
      />
    </Paper>
  );
};

export default DataTableSecond;
